export enum AccountSelectedStatus {
	Selected = 'SELECTED',
	Deselected = 'DESELECTED',
	Undecided = 'UNDECIDED',
}
